import {
  EClickableTypes,
  EClickableVariants,
} from '@/components/atoms/at-clickable/at-clickable.types';
import {
  IMlHeaderProps,
  EAlignment,
  EOrientation,
  EMlHeaderSize,
} from './ml-header.types';

export const mlHeaderMockData: IMlHeaderProps = {
  head: 'Trending Homes',
  body: 'Explore home plans tailored to where you live.',
  alignment: EAlignment.LEFT,
  order: EOrientation.VERTICAL,
  size: EMlHeaderSize.SMALL,
  ctaProps: {
    interactLocation: 'test',
    label: 'Browse MORE PLANS',
    href: '/home-plans',
    type: EClickableTypes.LINK,
    variant: EClickableVariants.PRIMARY,
  },
};
